<template>
  <v-card
    :height="h"
    :width="w"
    class="mr-2 mb-2"
    :class="scroll ? 'card-formatter' : ''"
  >
    <v-app-bar
      elevation="0"
      class="vue-draggable-handle"
      :style="{
        backgroundColor: bgColor,
        color: dark ? '#fff' : color,
      }"
      height="28px"
    >
      <v-app-bar-nav-icon>
        <slot name="icon" v-if="icon">
          <v-icon
            :style="{
              color: dark ? '#fff' : color,
            }"
            :dark="dark"
            >{{ icon }}</v-icon
          >
        </slot>
      </v-app-bar-nav-icon>

      <v-toolbar-title
        class="font-weight-bold text-truncate text-uppercase text-caption"
      >
        {{ title }}
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <slot name="toolbar"></slot>
      <v-btn
        v-if="searchButton"
        icon
        :dark="dark"
        small
        @click="$emit('search')"
        ><v-icon>mdi-magnify</v-icon></v-btn
      >
      <v-btn
        v-if="addButton"
        icon
        :dark="dark"
        small
        :color="color"
        @click="$emit('add')"
        ><v-icon>mdi-plus-circle</v-icon></v-btn
      >
      <v-btn
        v-if="closeButton"
        icon
        :dark="dark"
        small
        :color="color"
        @click="$emit('closed')"
        ><v-icon>mdi-close</v-icon></v-btn
      >
    </v-app-bar>

    <v-card-text class="px-0" :class="scroll ? 'scrollbar-formatter' : ''">
      <slot></slot>
    </v-card-text>
  </v-card>
</template>
    

    
    <script>
export default {
  name: "widget",
  props: {
    scroll: {
      type: Boolean,
      default: false,
    },

    closeButton: {
      type: Boolean,
      default: true,
    },
    searchButton: Boolean,
    addButton: Boolean,
    height: {
      type: String,
      default: "100%",
    },
    width: {
      type: String,
      default: "100%",
    },
    title: {
      type: String,
      default: "widget-title",
    },
    icon: String,
    bgColor: String,
    color: String,
    dark: Boolean,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    w() {
      return typeof this.width === "string" ? this.width : `${this.width}px`;
    },
    h() {
      return typeof this.height === "string" ? this.height : `${this.height}px`;
    },
  },
};
</script>
    
<style scoped>
.card-formatter {
  display: flex !important;
  flex-direction: column;
}
.scrollbar-formatter {
  flex-grow: 1;
  overflow: auto;
}
.v-toolbar {
  flex: 0;
}
.v-card__text{
  padding-top: 0px;
}
</style>